"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = void 0;
var design_system_theme_1 = require("@unmind/design-system-theme");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var typography_1 = require("../typography");
var icons_1 = require("../../icons");
var BUTTON_HORIZONTAL_PADDING = 12;
var CROSS_ICON_SIZE = 7;
var ChipSizeStyles = (_a = {},
    _a['small'] = [design_system_theme_1.FontSizes.fontSize14],
    _a['large'] = [design_system_theme_1.FontSizes.fontSize16],
    _a);
var ChipButton = styled_components_1.default.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  background: none;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n  padding: 6px ", "px;\n  border-radius: 20px;\n  outline-offset: 1px;\n  position: relative;\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  background: none;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n  padding: 6px ", "px;\n  border-radius: 20px;\n  outline-offset: 1px;\n  position: relative;\n\n  ", "\n"])), BUTTON_HORIZONTAL_PADDING, function (_a) {
    var $active = _a.$active, buttonActiveWidth = _a.buttonActiveWidth, theme = _a.theme;
    return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n\n    border: 1px solid ", ";\n\n    // order of CSS is important here! :hover should sit before :active,\n    // as users will typically be hovering the Chip while triggering active,\n    // meaning active would be overwritten if placed earlier.\n    &:active {\n      background-color: ", ";\n    }\n\n    &:focus {\n      outline: 2px solid ", ";\n    }\n  "], ["\n    ", "\n\n    border: 1px solid ", ";\n\n    // order of CSS is important here! :hover should sit before :active,\n    // as users will typically be hovering the Chip while triggering active,\n    // meaning active would be overwritten if placed earlier.\n    &:active {\n      background-color: ", ";\n    }\n\n    &:focus {\n      outline: 2px solid ", ";\n    }\n  "])), $active
        ? (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          background-color: ", ";\n          min-width: ", "px;\n        "], ["\n          background-color: ", ";\n          min-width: ", "px;\n        "])), theme.button.primary.default.backgroundColor, buttonActiveWidth) : (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          transition: background-color 0.2s;\n\n          &:hover {\n            background-color: ", ";\n          }\n        "], ["\n          transition: background-color 0.2s;\n\n          &:hover {\n            background-color: ", ";\n          }\n        "])), theme.button.secondary.default.hover
        .backgroundColor), theme.colors.border.primary, theme.button.primary.default.active.backgroundColor, theme.colors.text.primary);
});
var ChipLabel = (0, styled_components_1.default)(typography_1.BodyText).attrs(function (_a) {
    var $size = _a.$size, $active = _a.$active, theme = _a.theme;
    return ({
        sizes: ChipSizeStyles[$size],
        color: $active
            ? theme.colors.staticPalette.black
            : theme.colors.text.primary,
    });
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  line-height: 1;\n"], ["\n  line-height: 1;\n"])));
var crossIconActiveAnimation = (0, styled_components_1.keyframes)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n 0% { \n    opacity: 0;\n }\n 90% {\n    transform: translateX(5%) rotate(10deg);\n }\n 100% { \n    transform: translateX(0) rotate(0);\n    opacity: 1;\n }\n"], ["\n 0% { \n    opacity: 0;\n }\n 90% {\n    transform: translateX(5%) rotate(10deg);\n }\n 100% { \n    transform: translateX(0) rotate(0);\n    opacity: 1;\n }\n"])));
var CrossIconContainer = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  right: ", "px;\n  opacity: 0;\n  transform: translateX(-100%) rotate(-90deg);\n  animation-fill-mode: forwards;\n\n  ", "\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  right: ", "px;\n  opacity: 0;\n  transform: translateX(-100%) rotate(-90deg);\n  animation-fill-mode: forwards;\n\n  ", "\n"])), BUTTON_HORIZONTAL_PADDING, function (_a) {
    var $active = _a.$active;
    return $active && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      animation-name: ", ";\n      animation-duration: 0.3s;\n    "], ["\n      animation-name: ", ";\n      animation-duration: 0.3s;\n    "])), crossIconActiveAnimation);
});
var CrossIcon = (0, styled_components_1.default)(icons_1.Cross).attrs(function (_a) {
    var $active = _a.$active, theme = _a.theme;
    return ({
        width: CROSS_ICON_SIZE,
        height: CROSS_ICON_SIZE,
        primaryColor: $active
            ? theme.colors.staticPalette.black
            : theme.colors.text.primary,
    });
})(templateObject_9 || (templateObject_9 = __makeTemplateObject([""], [""])));
/**
 * A compact, clickable element allowing users to trigger an action.
 *
 * Chips are `button` elements under the hood, and clicking them toggles their `active` state.
 */
var Chip = function (_a) {
    var label = _a.label, onActivate = _a.onActivate, onDeactivate = _a.onDeactivate, _b = _a.size, size = _b === void 0 ? 'small' : _b;
    var _c = (0, react_1.useState)(false), active = _c[0], setActive = _c[1];
    var _d = (0, react_1.useState)(0), buttonActiveWidth = _d[0], setButtonActiveWidth = _d[1];
    var buttonRef = (0, react_1.useRef)(null);
    (0, react_1.useLayoutEffect)(function () {
        var _a, _b;
        var buttonWidth = (_b = (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) !== null && _b !== void 0 ? _b : 0;
        setButtonActiveWidth(buttonWidth + CROSS_ICON_SIZE + BUTTON_HORIZONTAL_PADDING / 2);
    }, []);
    var onChipClick = function () {
        if (active) {
            onDeactivate();
        }
        else {
            onActivate();
        }
        setActive(!active);
    };
    return (react_1.default.createElement(ChipButton, { onClick: onChipClick, "$active": active, ref: buttonRef, buttonActiveWidth: buttonActiveWidth, type: "button", "aria-pressed": active },
        react_1.default.createElement(ChipLabel, { "$size": size, "$active": active }, label),
        react_1.default.createElement(CrossIconContainer, { "$active": active, "aria-hidden": "true" },
            react_1.default.createElement(CrossIcon, { "$active": active }))));
};
exports.Chip = Chip;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
